<mat-form-field class="m-r-16">
  <mat-label>{{ 'common.year' | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedYear" (ngModelChange)="onSelectionChange()">
    <mat-option *ngFor="let year of years" [value]="year">
      {{ year }}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field *ngIf="showMonth">
  <mat-label>{{ 'common.month' | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedMonth" (ngModelChange)="onSelectionChange()">
    <mat-option *ngFor="let month of months" [value]="month">
      <ng-container>
        {{ month.name | translate }}
      </ng-container>
    </mat-option>
  </mat-select>
</mat-form-field>
